import type { ActionReducerMap } from '@ngrx/store';

import { authReducer } from './auth/auth.reducer';
import type { AuthState } from './auth/auth.state';
import { paginationReducer } from './pagination/pagination.reducer';
import type { PaginationState } from './pagination/pagination.state';
import { PERMISSION_REDUCER } from './permission/permission.reducers';
import type { PermissionProfileState } from './permission/permission.state';
import { viewsReducer } from './views/views.reducer';
import type { ViewsState } from './views/views.state';

export interface AppState {
  permission: PermissionProfileState;
  pagination: PaginationState;
  auth: AuthState;
  views: ViewsState;
}

export const REDUCERS: ActionReducerMap<AppState> = {
  permission: PERMISSION_REDUCER,
  pagination: paginationReducer,
  auth: authReducer,
  views: viewsReducer,
};
